<template>
  <div class="jl-account-refund-wrap">
    <div class="jl-acc-refund-box">
      <div class="jl-refund-top">
        <span class="span-text">拍卖结束时间：</span>
        <div class="input-ground alt-text">
          <el-date-picker v-model="end_date" type="datetime" placeholder="选择日期"></el-date-picker>
          <!-- <i class="jl-icon jl-icon-date"></i> -->
        </div>
        <span class="span-text">状态：</span>
        <div class="input-ground alt-select">
          <!-- <div class="record-select">
            <div class="record-select-box">
              <p :class="[isShowSelect?'text active' : 'text']" @click="showSelect">
                {{selectText}}
                <i class="jl-icon-sanjiao_down"></i>
              </p>
              <transition name="fade-down">
                <div class="record-select-down" v-show="isShowSelect">
                  <ul class="list">
                    <li
                      v-for="(item, index) in selectOption"
                      :key="index"
                      @click="selectClick(item)"
                      :class="[selectText === item.label?'selected':'']"
                    >{{item.label}}</li>
                  </ul>
                </div>
              </transition>
            </div>
          </div>-->
          <el-select v-model="typeValue" placeholder="请选择">
            <el-option
              v-for="item in selectOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="input-ground alt-search">
          <input class="input" type="text" v-model.trim="keyword" placeholder="请输入拍品名称搜索" />
          <i class="jl-icon jl-icon-search alt-search"></i>
        </div>
        <div class="input-ground alt-submit">
          <button class="submit-btn" @click="search">查询</button>
        </div>
      </div>
      <div class="jl-refund-content">
        <div class="table-wrap">
          <table class="table">
            <thead>
              <tr>
                <th>编号</th>
                <th>拍品名称</th>
                <th>押金</th>
                <th>拍卖结束时间</th>
                <th>状态</th>
                <th>退款时间</th>
              </tr>
            </thead>
          </table>

          <div v-loading="isloading" class="jl-loading-box">
            <div class="jl-com-nodata-tips" v-if="nodata">
              <div class="jl-com-nodata-box">
                <i class="jl-icon-wushuju"></i>
                <p class="text">暂无数据</p>
              </div>
            </div>
            <table class="table">
              <tbody>
                <template v-for="(item, index) in list">
                  <tr :key="item.id">
                    <td>
                      <p class="text">{{display * (current - 1) + (index + 1)}}</p>
                    </td>
                    <td>
                      <p class="text">{{item.tauctionNper ? item.tauctionNper.name : ""}}</p>
                    </td>
                    <td>
                      <p class="text">￥ {{item.deposit}}</p>
                    </td>
                    <td>
                      <p class="text">{{item.auctionNperDate}}</p>
                    </td>
                    <td>
                      <p class="text table-refund-status error" v-if="item.isRefund === 0">未退还</p>
                      <p class="text table-refund-status" v-if="item.isRefund === 1">已退还</p>
                    </td>
                    <td>
                      <p class="text">{{item.refundDate}}</p>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="jl-refund-content-footer clearfix">
          <div class="jl-refund-f-tips">
            <p class="text1">若有退款异常请通过下方电话或者邮箱联系我们</p>
          </div>
          <div class="page-wrap">
            <div class="jl-page-box clearfix" v-if="list.length > 0">
              <div style="float: right">
                <v-pagination
                  :total="total"
                  :display="display"
                  :currentPage="current"
                  @pagechange="pagechange"
                ></v-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { gerRefundList } from "../../../api/user";
import Pagination from "@/components/Pagination";
export default {
  name: "accountRefundRecord",
  components: {
    "v-pagination": Pagination
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  data() {
    return {
      end_date: "", //拍卖结束时间
      isShowSelect: false,
      selectText: "已退还",
      selectOption: [
        {
          value: "1",
          label: "已退还"
        },
        {
          value: "0",
          label: "未退还"
        }
      ],
      typeValue: "1",
      list: [],
      total: 1,
      display: 10,
      current: 1,
      keyword: "",
      isloading: true,
      nodata: false
    };
  },
  methods: {
    search() {
      this.current = 1;
      this.getlist();
    },
    getlist() {
      gerRefundList(this);
    },
    pagechange(idx) {
      //console.log(idx);
      this.current = idx;
      this.getlist();
      window.scrollTo(0, 0);
    }
  },
  created() {
    this.getlist();
  }
};
</script>

<style lang="scss" scoped>
.fade-down-enter-active,
.fade-down-leave-active {
  transition: all 0.3s ease;
}
.fade-down-enter, 
.fade-down-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(20px);
  opacity: 0;
}
.jl-acc-refund-box {
  padding: 30px;
  background: #fff;
  min-height: 450px;
}
.jl-refund-top {
  font-size: 14px;
  color: #333;
  .input-ground,
  .span-text {
    display: inline-block;
    vertical-align: middle;
  }
  .input-ground {
    position: relative;
    margin-right: 28px;
    &.alt-text {
      width: 204px;
    }
    &.alt-select {
      width: 113px;
    }
    &.alt-search {
      width: 299px;
      margin-right: 10px;
      .input {
        padding-left: 34px;
      }
    }
    .jl-icon {
      position: absolute;
      right: 13px;
      top: 50%;
      transform: translateY(-50%);
      color: #6f6f6f;
      &.alt-search {
        right: auto;
        left: 13px;
      }
    }
  }
  .input {
    display: inline-block;
    width: 100%;
    height: 36px;
    line-height: 36px;
    padding: 0 13px;
    border: 1px solid #e0e0e0;
  }
  .submit-btn {
    width: 58px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 14px;
    counter-reset: #e70819;
    background: #fff;
    color: #e70819;
    border: 1px solid #e70819;
    cursor: pointer;
  }
}
.jl-refund-content {
  padding-top: 24px;
}
.jl-refund-content-footer {
  margin-top: 30px;
  position: relative;
  .jl-refund-f-tips {
    position: absolute;
    left: 0;
    top: 0;
    .text1 {
      font-size: 14px;
      color: #e70819;
      line-height: 30px;
      padding-left: 20px;
      background: url("../../../assets/img/zkj-form-tips.png") no-repeat left
        center;
    }
  }
  .page-wrap {
    float: right;
  }
}
.table-wrap {
  .table {
    width: 100%;
    max-width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
    thead {
      background: #eff2f5;
    }
    tbody {
      tr {
        &:nth-child(2n) {
          background: #f8f8fb;
        }
      }
    }
    th,
    td {
      width: 16.66%;
      text-align: center;
      font-size: 14px;
      color: #333;
      font-weight: 500;
      padding: 15px 0;
      &:first-child {
        text-align: left;
        padding-left: 30px;
      }
    }
    td {
      padding: 15px 0;
      text-align: center;
      .text {
        font-size: 14px;
        color: #666;
        text-align: center;
      }
      &:first-child {
        padding-left: 30px;
        .text {
          text-align: left;
        }
      }
    }
  }
  .table-refund-status {
    position: relative;
    display: inline-block;
    padding-left: 16px;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      width: 8px;
      height: 8px;
      border-radius: 4px;
      margin-top: -4px;
      background: #666;
    }
    &.error {
      color: #e70819;
      &::before {
        background: #e70819;
      }
    }
  }
}

.record-select-box {
  position: relative;
}
.record-select {
  width: 92px;
  height: 36px;
  .text {
    position: relative;
    padding-left: 15px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    color: #333;
    border: 1px solid #e0e0e0;
    cursor: pointer;
    i {
      display: inline-block;
      transition: all 0.3s;
    }
    &.active {
      i {
        transform: rotate(180deg);
      }
    }
  }
}
.record-select-down {
  position: absolute;
  left: 0;
  top: 100%;
  padding-top: 12px;
  width: 100%;
  .list {
    position: relative;
    background: #fff;
    box-shadow: 0 0 15px rgba(184, 184, 184, 0.5);
    z-index: 100;
    &::before {
      content: "";
      position: absolute;
      top: -5px;
      right: 10px;
      width: 10px;
      height: 10px;
      background: #fff;
      transform: rotate(45deg);
      z-index: -1;
    }
    li {
      height: 44px;
      line-height: 44px;
      text-align: center;
      font-size: 14px;
      color: #333;
      border-bottom: 1px solid #e0e0e0;
      cursor: pointer;
      &:last-child {
        border-bottom: none;
      }
      &.selected {
        background: #e50011;
        color: #fff;
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .record-select-down .list li:hover {
    background: #e50011;
    color: #fff;
  }
}
</style>

<style>
.jl-refund-top .el-input__inner {
  height: 36px;
  line-height: 36px;
}
.jl-refund-top .el-input__icon {
  line-height: 36px;
}
.jl-refund-top .input-ground.alt-text > div {
  width: 100%;
}
</style>

